import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { styled } from "@mui/system";

export default function Popup(props) {
  const [open, setOpen] = React.useState(true);
  const [scroll, setScroll] = React.useState("paper");
  const title = props.title ? props.title : "";
  const style = props.style ? props.style : "";

  const handleClose = () => {
    props.onClose();
  };

  const descriptionElementRef = React.useRef(null);
  React.useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);

  const CustomDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialog-paper": {
      maxWidth: "none",
      backgroundColor: "transparent",
    },
    "& .MuiDialogTitle-root": {
      borderRadius: "17px 17px 0px 0px",
      padding: "1% 1% 0 1%",
      background: "#fff",
    },
    "& .MuiDialogTitle-root button": {
      padding: "0px",
    },
    "& .MuiDialogTitle-root img": {
      width: "100%",
    },
    "& .MuiDialogContent-root": {
      borderTop: "0px",
      borderBottom: "0px",
      background: "#fff",
      borderRadius: "0px 0px 17px 17px",
    },
    "& .MuiDialogContentText-root img": {
      width: "100%",
    },
  }));

  return (
    <div>
      <CustomDialog
        open={open}
        onClose={handleClose}
        scroll={scroll}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >
        <DialogTitle id="scroll-dialog-title" style={style.title}>
          <Button onClick={handleClose}>
            <img src={title} />
          </Button>
        </DialogTitle>
        <DialogContent dividers={scroll === "paper"} style={style.content}>
          <DialogContentText id="scroll-dialog-description" ref={descriptionElementRef} tabIndex={-1}>
            {props.children}
          </DialogContentText>
        </DialogContent>
      </CustomDialog>
    </div>
  );
}
